import { useMemo } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSubscribers } from "../../hooks/useAdministration";

const Abonnes = (props) => {
  const subscribersQ = useSubscribers();
  const abonnes = subscribersQ.data || [];

  const columns = useMemo(
    () => [
      {
        Header: props.t("No."),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">{abo.row.index + 1}</h5>
              </div>
            </div>
          </>
        ),
        filterable: false,
      },
      {
        Header: props.t("Abonnés"),
        accessor: "nom",
        Cell: (abo) => (
          <>
            <Link
              to={`/admin-abonne-detail/${abo.row.original.id}/`}
              className="text-warning d-inline-block"
            >
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="fs-14 mb-1">
                    {abo.row.original.first_name
                      ? abo.row.original.last_name
                        ? abo.row.original.last_name +
                          " " +
                          abo.row.original.first_name
                        : abo.row.original.first_name
                      : ""}
                  </h5>
                </div>
              </div>
            </Link>
          </>
        ),
        filterable: false,
      },
      {
        Header: props.t("Adresse"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.adresse ? abo.row.original.adresse : ""}
                </h5>
              </div>
            </div>
          </>
        ),
        filterable: false,
      },
      {
        Header: props.t("Téléphone"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.telephone ? abo.row.original.telephone : ""}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Pays"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.pays ? abo.row.original.pays : ""}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Société"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.societe ? abo.row.original.societe : ""}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Fonction"),
        Cell: (abo) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  {abo.row.original.fonction ? abo.row.original.fonction : ""}
                </h5>
              </div>
            </div>
          </>
        ),
      },
    ],
    [],
  );

  document.title = props.t("Liste des abonnés | Le Conseiller du BTP");

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      <Container fluid>
        <BreadCrumb
          title={props.t("Abonnés")}
          pageTitle={props.t("Liste des abonnés")}
        />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardBody className="pt-0">
                <div>
                  {abonnes && abonnes.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={abonnes || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={25}
                      className="custom-header-css"
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-middle table-nowrap"
                      theadClass="table-light"
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/msoeawqm.json"
                          trigger="loop"
                          colors="primary:#405189,secondary:#0ab39c"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>

                      <div className="mt-4">
                        <h5>{props.t("Sorry! No Result Found")}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Abonnes.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Abonnes));
